import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useDynamicStyles } from '../hooks';
import { Button, ButtonVariants } from './Button';
import { Modal } from './Modal';
import { TextBold, TextReg } from './StyledText';

type Props = {
  visible: boolean;
  onClose: () => void;
  onViewProfile: () => void;
};

export function FirstFavoriteCelebrationModal({
  visible,
  onClose,
  onViewProfile,
}: Props) {
  const styles = useDynamicStyles(createStyles);

  const handleViewProfilePress = () => {
    onViewProfile();
    onClose(); // Close modal after navigating to profile
  };

  return (
    <Modal
      visible={visible}
      hide={onClose}
      fullscreenOnBreakpoint={false}
      size="small"
      modalStyle={styles.modal}
      contentStyle={styles.content}
    >
      <View style={styles.celebration}>
        <TextBold style={styles.emoji}>🎉</TextBold>
        <TextBold style={styles.title}>Congratulations!</TextBold>
        <TextReg style={styles.subtitle}>
          You saved your first session! You can view all your saved sessions on
          your profile.
        </TextReg>
      </View>

      <View style={styles.buttonContainer}>
        <Button
          mode="contained"
          variant={ButtonVariants.PURPLE}
          onPress={handleViewProfilePress}
          style={styles.profileButton}
        >
          View Profile
        </Button>
      </View>
    </Modal>
  );
}

const createStyles = () =>
  StyleSheet.create({
    modal: {
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: 16,
      paddingTop: 0,
    },
    content: {
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 32,
    },
    celebration: {
      width: '100%',
      alignItems: 'center',
    },
    emoji: {
      fontSize: 64,
      marginBottom: 16,
    },
    title: {
      fontSize: 24,
      marginBottom: 12,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 16,
      textAlign: 'center',
    },
    buttonContainer: {
      width: '100%',
    },
    profileButton: {
      width: '100%',
    },
  });
